import React from 'react'
import { useTranslation } from 'react-i18next'
import { Content, Box, Button, Icon } from '@qure/containers'

import { useHistory } from 'react-router-dom'

const UnAuthorized = () => {
  const history = useHistory()
  const { t } = useTranslation()

  return (
    <Box className="column is-6 has-text-centered is-offset-3">
      <Icon
        color="primary"
        containerClassName="my-5"
        iConClass="fas fa-lock fa-3x"
      />
      <Content.Title>
        <div className="mb-4 has-text-primary">{t('Unauthorised access')}</div>
      </Content.Title>
      <Content.Subtitle>
        <div className="column my-4">
          {t('This page is not available for your login credentials')}
        </div>
      </Content.Subtitle>
      <Button
        isPrimary
        className="mb-4"
        onClick={() => {
          history.push('/')
        }}
      >
        {t('Return to Dashboard')}
      </Button>
    </Box>
  )
}

UnAuthorized.propTypes = {}

export default UnAuthorized
